import { defineStore } from "pinia";
import { UserTask } from "@/types/entity";
import { UserTaskStatus, UserTaskType } from "@/enums/mateEnums";
import {
  ApiGetUserTaskPage,
  ApiGetUserTask,
  ApiUpdateUserTaskProgress,
  ApiClaimTaskReward,
} from "@/apis/userTask";

interface UserTaskState {
  taskList: number[];
  taskMap: Map<number, UserTask>;
  activeFilter: {
    status?: UserTaskStatus;
    type?: UserTaskType;
  };
  showTaskDetailModal: boolean;
  activeTaskId: number | null;
}

export const useUserTask = defineStore("userTask", {
  state: (): UserTaskState => ({
    taskList: [],
    taskMap: new Map(),
    activeFilter: {},
    showTaskDetailModal: false,
    activeTaskId: null,
  }),

  getters: {
    filteredTasks(state): UserTask[] {
      return state.taskList
        .map((id) => state.taskMap.get(id))
        .filter((task): task is UserTask => !!task)
        .filter((task) => {
          if (
            state.activeFilter.status &&
            task.userStatus !== state.activeFilter.status
          ) {
            return false;
          }
          if (
            state.activeFilter.type &&
            task.type !== state.activeFilter.type
          ) {
            return false;
          }
          return true;
        })
        .sort((a, b) => {
          // userStatus 为 completed 的排在前面
          if (a.userStatus === UserTaskStatus.COMPLETED) {
            return -1;
          }
          if (b.userStatus === UserTaskStatus.COMPLETED) {
            return 1;
          }
          // userStatus 为 claimed 的排在最后边
          if (a.userStatus === UserTaskStatus.CLAIMED) {
            return 1;
          }
          if (b.userStatus === UserTaskStatus.CLAIMED) {
            return -1;
          }
          // userStatus 为 in_progress 的排在中间
          // if (a.userStatus === UserTaskStatus.IN_PROGRESS) {
          //   return 0;
          // }
          // if (b.userStatus === UserTaskStatus.IN_PROGRESS) {
          //   return 0;
          // }
          // return b.priority - a.priority;
          return b.priority - a.priority;
        });
    },

    activeTask(state): UserTask | null {
      return state.activeTaskId
        ? state.taskMap.get(state.activeTaskId) || null
        : null;
    },
  },

  actions: {
    async fetchTasks() {
      // const { length } = this.taskList;

      // if (length % 20 !== 0) {
      //   return true;
      // }

      // const page = this.taskList.length / 20 + 1;
      const response = await ApiGetUserTaskPage({
        pagination: { page: 1, perPage: 999 },
        filter: {
          status: this.activeFilter.status || undefined,
          type: this.activeFilter.type || undefined,
        },
        sort: { field: "priority", order: "desc" },
      });

      const tasks = response.page.data;

      tasks.forEach((task) => {
        this.taskMap.set(task.id!, task);
        if (!this.taskList.includes(task.id!)) {
          this.taskList.push(task.id!);
        }
      });
      return false;
    },

    async getTaskDetail(id: number) {
      if (!this.taskMap.has(id)) {
        const response = await ApiGetUserTask(id);
        this.taskMap.set(id, response.data);
      }
      return this.taskMap.get(id);
    },

    async updateTaskProgress(id: number, progress: number) {
      const response = await ApiUpdateUserTaskProgress(id, progress);
      this.taskMap.set(id, response.item);
    },

    async claimReward(id: number) {
      const response = await ApiClaimTaskReward(id);
      if (response.data.itemzz.length) {
        const task = this.taskMap.get(id);
        if (task) {
          task.rewards = response.data.itemzz;
          task.userStatus = UserTaskStatus.CLAIMED;
        }
      }
      return response.data.itemzz;
    },

    openTaskDetail(id: number) {
      this.activeTaskId = id;
      this.showTaskDetailModal = true;
    },

    closeTaskDetail() {
      this.showTaskDetailModal = false;
      this.activeTaskId = null;
    },

    clear() {
      this.taskList = [];
      this.taskMap.clear();
    },
  },
});
